import jsonLdHelper from './jsonLdHelper'

const jsonLd = (id, json, product) => ({
    ...jsonLdHelper,
    completeJson: json,
    init() {
        window.api.getPricesAndStock([{ id, quantity: 1, index: 0 }]).then((result) => {
            if (Object.prototype.hasOwnProperty.call(result, id)) {
                this.applyOfferFromPriceAndStock(result[id].data)
                this.applyBrandFromPriceAndStock(result[id].data)
            }

            this.completeJson.name = product.minimal_quantity > 1 ? product.name.substring(0, 136) + ' (pack of ' + product.minimal_quantity + ')' : product.name

            this.buildMarkup()
        })
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('jsonLd', jsonLd)
})
